/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEcommContentTemplate1 contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum imageAlignment {
    left = 'left',
    right = 'right'
}

export interface IEcommContentTemplate1Config extends Msdyn365.IModuleConfig {
    title?: string;
    enablePrimaryColour?: boolean;
    description?: Msdyn365.RichText;
    image?: Msdyn365.IImageData;
    imageAlignment?: imageAlignment;
    anchorID?: string;
    className?: string;
}

export interface IEcommContentTemplate1Props<T> extends Msdyn365.IModule<T> {
    config: IEcommContentTemplate1Config;
}
